import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  Tooltip,
  createTheme,
  CssBaseline,
} from '@mui/material';
import {
  VpnKey as VaultIcon,
  CompareArrows as MigrateIcon,
  Home as HomeIcon,
  Balance as CloneIcon,
  Receipt as TransactionIcon,
} from '@mui/icons-material';
import './styles.css';
import config from "../../../src/env.json";
// import '@fortawesome/fontawesome-free/css/all.min.css';
import { ThemeProvider } from '@emotion/react';
const theme = createTheme({
  palette: {
    primary: {
      main: "#673AB7",
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const drawerWidth = 185;
const collapsedWidth = 60;

const DatabaseMenu: React.FC = () => {
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  const menuItems = [
    // { text: 'All Keyvaults', icon: <HomeIcon />, path: '/Keyvaults' },
    { text: 'Migration Tool', icon: <MigrateIcon />, path: '/DatabaseConfigurations' },
    // { text: 'Transactions', icon: <TransactionIcon />, path: '/DatabaseConfigurations/transactions' },
  ];

  // function to check if a menu item should be selected
  const isSelected = (path: string) => {
    return location.pathname === path || (path === '/keyvault' && location.pathname === '/keyvault');
  };

    useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', config.REACT_APP_MAIN_APP_CSS_PRIMARY_COLOR || '#1976d2');
    document.documentElement.style.setProperty('--secondary-color', config.REACT_APP_MAIN_APP_CSS_SECONDARY_COLOR || '#dc004e');
    document.documentElement.style.setProperty('--tertiary-color', config.REACT_APP_MAIN_APP_CSS_TERTIARY_COLOR || '#9c27b0');
    document.documentElement.style.setProperty('--primary-text-color', config.REACT_APP_MAIN_APP_CSS_PRIMARY_TEXT_COLOR || 'rgba(0, 0, 0, 0.87)');
    document.documentElement.style.setProperty('--secondary-text-color', config.REACT_APP_MAIN_APP_CSS_SECONDARY_TEXT_COLOR || 'rgba(0, 0, 0, 0.6)');
    document.documentElement.style.setProperty('--placeholder-text-color', config.REACT_APP_MAIN_APP_CSS_PLACEHOLDER_TEXT_COLOR || 'rgba(0, 0, 0, 0.38)');
  }, []);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{
          width: hovered ? drawerWidth : collapsedWidth,
          transition: 'width 0.3s ease',
          flexShrink: 0,
          whiteSpace: 'nowrap',
          overflowX: 'hidden',
          ml: '70px', // 👈 Offset for main sidebar width
          mt: '60px', // 👈 Offset for main sidebar width
          [`& .MuiDrawer-paper`]: {
            width: hovered ? drawerWidth : collapsedWidth,
            transition: 'width 0.3s ease',
            overflowX: 'hidden',
            overflowY: 'auto',
            boxSizing: 'border-box',
            ml: '70px', // 👈 Make sure the paper is also offset
            mt: '60px'
          },
        }}
      >
        {/* <Toolbar /> */}
        <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
          <List>
            {menuItems.map((item) => (
              <Tooltip
                key={item.text}
                title={!hovered ? item.text : ''}
                placement="right"
                arrow
              >
                <ListItem
                  button
                  component={Link}
                  to={item.path}
                  selected={isSelected(item.path)}
                  sx={{
                    px: hovered ? 3 : 1.5,
                    backgroundColor: 'transparent',
                    '&.Mui-selected': {
                      '&:hover': {
                      },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: hovered ? 2 : 'auto', 
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  {hovered && <ListItemText primary={item.text} primaryTypographyProps={{ style: { color: 'black' } }}/>}
                </ListItem>
              </Tooltip>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
      
    </ThemeProvider>
  );
};

export default DatabaseMenu;
